/* Vendored shadcn/ui. */
import { cn } from '@/lib/utils';

export function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    <label
      className={cn(
        'text-[length:var(--ui-font)] font-medium leading-none text-[var(--foreground)] select-none',
        className,
      )}
      {...props}
    />
  );
}
